import { AssetClassEvent } from './asset-class.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetClassPutEvent extends AssetClassEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.id}`,
            type: AssetClassPutEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetClassPutEvent.type = 'com.treeplotter.api.asset-class.put.v1';
EventRegistry.register(AssetClassPutEvent.type, AssetClassPutEvent);
//# sourceMappingURL=asset-class-put.event.js.map